import { WorkOrderStatus } from '../data-models/work-order-status.model';
import { WorkOrder } from '../data-models/work-order.model';

/** Pilot-friendly label per the 2026-05-15 design decision. */
export function workOrderStatusLabel(status: WorkOrderStatus): string {
  switch (status) {
    case 'open':
      return 'Scheduled';
    case 'in_progress':
      return 'In Progress';
    case 'completed':
      return 'Complete';
    case 'cancelled':
      return 'Cancelled';
  }
}

/**
 * Bootstrap badge class for a status pill. Picked to match the rest
 * of the app's badge conventions (Spray Records uses the same family).
 */
export function workOrderStatusBadgeClass(status: WorkOrderStatus): string {
  switch (status) {
    case 'open':
      return 'badge bg-primary-subtle text-primary';
    case 'in_progress':
      return 'badge bg-warning-subtle text-warning';
    case 'completed':
      return 'badge bg-success-subtle text-success';
    case 'cancelled':
      return 'badge bg-danger-subtle text-danger';
  }
}

/**
 * "From CropSwipe" if the WO is linked to a marketplace job, else
 * "Manual". Used by the list + detail screens.
 */
export function workOrderSourceLabel(wo: WorkOrder): 'From CropSwipe' | 'Manual' {
  return wo.jobId ? 'From CropSwipe' : 'Manual';
}

/**
 * Human-readable location for a WO. Prefers field city/state and
 * falls back to the customer's address when the field carries none.
 * Returns an empty string when nothing is known so the caller can
 * decide on its own placeholder.
 */
export function workOrderLocationDisplay(wo: WorkOrder): string {
  const fieldLoc = [wo.fieldCity, wo.fieldState]
    .filter((s) => s && s.trim())
    .join(', ');
  if (fieldLoc) return fieldLoc;
  const customerLoc = [wo.customerCity, wo.customerState]
    .filter((s) => s && s.trim())
    .join(', ');
  return customerLoc;
}

/** Acreage shown on summary cards — prefers actual, falls back to estimated. */
export function workOrderAcresDisplay(wo: WorkOrder): number | null {
  return wo.actualAcres ?? wo.estimatedAcres ?? null;
}
